// V24 — AI-first form constants + completeness scorer shared by all forms.
// Keep in sync with backend `tutor_matching.LEAD_CRITICAL_FIELDS` /
// `TUTOR_CRITICAL_FIELDS` so the live UI meter matches the server score.

export const PREFERRED_DAYS = [
    { value: "Mon" }, { value: "Tue" }, { value: "Wed" }, { value: "Thu" },
    { value: "Fri" }, { value: "Sat" }, { value: "Sun" },
];

export const PREFERRED_TIME_WINDOWS = [
    { value: "morning", label: "Morning (6–11 am)" },
    { value: "afternoon", label: "Afternoon (12–4 pm)" },
    { value: "evening", label: "Evening (5–8 pm)" },
    { value: "late_evening", label: "Late Evening (8–10 pm)" },
];

export const CLASS_DURATIONS = [
    { value: 45 }, { value: 60 }, { value: 75 }, { value: 90 }, { value: 120 },
];

export const LEARNING_LEVELS = [
    { value: "average", label: "Average / On Grade Level" },
    { value: "advanced", label: "Advanced / Accelerated" },
    { value: "needs_support", label: "Needs Support / Remedial" },
];

export const FEE_TYPES = [
    { value: "monthly", label: "Monthly" },
    { value: "session_wise", label: "Per Session" },
    { value: "full_course", label: "Full Course" },
];

// Lead — keep aligned with backend LEAD_CRITICAL_FIELDS / LEAD_OPTIONAL_FIELDS.
const LEAD_CRIT = ["grade", "subjects", "board", "mode", "country", "city", "language_preference"];
const LEAD_OPT = [
    "state", "pin_code", "preferred_days", "preferred_time_window",
    "class_duration_minutes", "quoted_fee", "exam_goal",
    "curriculum_preference", "learning_level", "preferred_tutor_gender",
];

// Tutor — aligned with TUTOR_CRITICAL_FIELDS / TUTOR_OPTIONAL_FIELDS.
const TUTOR_CRIT = ["subjects_list", "grades_list", "boards_list", "languages", "gender", "qualification"];
const TUTOR_OPT = [
    "city", "state", "country", "teaching_pin_codes", "online_countries",
    "preferred_days", "preferred_time_slots", "class_duration_supported",
    "fee_expectation_min", "fee_expectation_max",
    "exam_categories", "curriculum_types", "max_travel_km",
    "preferred_student_gender", "demo_available", "max_students_capacity",
    "device_ready",
];

const filled = (obj, key) => {
    const v = obj?.[key];
    if (v == null || v === "") return false;
    if (Array.isArray(v) && v.length === 0) return false;
    if (typeof v === "object" && !Array.isArray(v) && Object.keys(v).length === 0) return false;
    return true;
};

function pct(obj, crit, opt) {
    const cMax = crit.length;
    const oMax = opt.length;
    const denom = cMax * 2 + oMax;
    if (denom === 0) return 0;
    let num = 0;
    for (const k of crit) if (filled(obj, k)) num += 2;
    for (const k of opt) if (filled(obj, k)) num += 1;
    return Math.round((100 * num) / denom);
}

export function leadCompleteness(lead = {}) {
    return pct(lead, LEAD_CRIT, LEAD_OPT);
}

export function tutorCompleteness(tutor = {}) {
    return pct(tutor, TUTOR_CRIT, TUTOR_OPT);
}

export function confidenceLabel(percent) {
    if (percent >= 75) return { label: "High", tone: "emerald" };
    if (percent >= 50) return { label: "Medium", tone: "amber" };
    return { label: "Low", tone: "red" };
}
